/** A titled region of a screen: heading, one action, a body, and an optional footer. */

import type { CSSProperties, ReactNode } from "react";

import { cn } from "@/lib/cn";

import "./Panel.css";

export interface PanelProps {
  readonly title?: ReactNode;
  readonly subtitle?: ReactNode;
  readonly action?: ReactNode;
  readonly footer?: ReactNode;
  readonly tone?: "default" | "sunken";
  readonly padding?: "default" | "none";
  readonly className?: string;
  readonly style?: CSSProperties;
  readonly children?: ReactNode;
}

export function Panel({
  title,
  subtitle,
  action,
  footer,
  tone = "default",
  padding = "default",
  className,
  style,
  children,
}: PanelProps) {
  const headed = title !== undefined || subtitle !== undefined || action !== undefined;
  return (
    <section
      className={cn("al-panel", `al-panel-${tone}`, `al-panel-pad-${padding}`, className)}
      style={style}
    >
      {headed ? (
        <header className="al-panel-head">
          <div className="al-panel-heading">
            {title !== undefined ? <h2 className="al-panel-title">{title}</h2> : null}
            {subtitle !== undefined ? <div className="al-panel-subtitle">{subtitle}</div> : null}
          </div>
          {action !== undefined ? <div className="al-panel-action">{action}</div> : null}
        </header>
      ) : null}
      <div className="al-panel-body">{children}</div>
      {footer !== undefined ? <footer className="al-panel-footer">{footer}</footer> : null}
    </section>
  );
}
